<div class="profile" [ngClass]="user?.userTypeClass">
  <div class="profile-detail">
    <app-user-avatar
      [size]="40"
      [avatarUrl]="authService?.currentUser?.avatarUrl"
      [profileColor]="authService?.currentUser?.profileColor"
      [initials]="authService?.currentUser?.initials"
    ></app-user-avatar>
    <div class="profile-text">
      <h5>{{ authService?.currentUser?.fullName }}</h5>
      <span>{{ 'dashboard.referralNumber' | translate }}: {{ authService?.currentUser?.referralCode }}</span>
    </div>
  </div>
  <button nz-button nzType="text" class="log-out" (click)="openLogOutConfirmationModal()">
    <i nz-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path
          d="M8.50215 11.9995C9.05562 11.9995 9.5043 12.4482 9.5043 13.0017C9.5043 13.5552 9.05562 14.0038 8.50215 14.0038C7.94868 14.0038 7.5 13.5552 7.5 13.0017C7.5 12.4482 7.94868 11.9995 8.50215 11.9995ZM12 4.8537V10.9995L12.0005 11.5045L19.442 11.5035L17.7196 9.77977C17.4534 9.51346 17.4292 9.09679 17.6471 8.80321L17.7198 8.71911C17.9861 8.45289 18.4027 8.42875 18.6963 8.64666L18.7804 8.71929L21.777 11.7169C22.043 11.983 22.0674 12.3992 21.85 12.6928L21.7775 12.7769L18.7809 15.7803C18.4884 16.0736 18.0135 16.0741 17.7203 15.7816C17.4537 15.5156 17.429 15.099 17.6465 14.8051L17.7191 14.7209L19.432 13.0035L12.0005 13.0045L12 19.7495C12 20.2159 11.5788 20.5692 11.1196 20.4881L2.61955 18.9868C2.26121 18.9235 2 18.6121 2 18.2482V6.24953C2 5.88222 2.26601 5.56896 2.62847 5.50944L11.1285 4.11361C11.5851 4.03863 12 4.39097 12 4.8537ZM10.5 5.7369L3.5 6.88641V17.6191L10.5 18.8555V5.7369ZM13 19.0008L13.7652 19.001L13.867 18.9941C14.2335 18.9443 14.5158 18.6299 14.5152 18.2497L14.508 13.9995H13V19.0008ZM13.002 10.4995L13 9.22487V5.49952L13.7453 5.49953C14.1245 5.49953 14.4381 5.78105 14.4883 6.14664L14.4953 6.24829L14.502 10.4995H13.002Z"
          fill="#EEEEEF"
        />
      </svg>
    </i>
  </button>
</div>
<nz-modal
  [nzVisible]="logOutDialogVisible()"
  (nzVisibleChange)="logOutDialogVisible.set($event)"
  (nzOnCancel)="closeLogOutConfirmationModal()"
  nzWrapClassName="modal-wrap"
  [nzCentered]="true"
  [nzClosable]="false"
  [nzWidth]="608"
  [nzFooter]="null"
>
  <ng-template nzModalContent>
    <app-log-out-confirmation-modal
      (cancelled)="closeLogOutConfirmationModal()"
      (confirmed)="confirmLogOut()"
    ></app-log-out-confirmation-modal>
  </ng-template>
</nz-modal>
